import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTCLI_By_confirming_this_offerX_you__ELL,
  TXTWCL_At_any_timeX_you_may_XXsurrend_ELL,
  TXTWCL_This_can_be_managed_via_XXMy_S_ELL
} from './TermsAndConditionsLink.messages.json';

interface Props {
  isBonusWithCost: boolean;
}
const TermsAndConditionsLink: React.FC<Props> = ({ isBonusWithCost }) => (
  <>
    {isBonusWithCost && (
      <>
        <Translation {...TXTWCL_At_any_timeX_you_may_XXsurrend_ELL} />
        <Translation {...TXTWCL_This_can_be_managed_via_XXMy_S_ELL} />
      </>
    )}
    <Translation
      tagName="p"
      {...TXTCLI_By_confirming_this_offerX_you__ELL}
      values={{
        a: (msg: React.ReactNode) => (
          <ResolverLink resolverTag={ResolverTag.InstantBonusTermsPurchase}>{msg}</ResolverLink>
        )
      }}
    />
  </>
);

export default TermsAndConditionsLink;
